import { render, staticRenderFns } from "./Story_Content.vue?vue&type=template&id=886eed20&"
import script from "./Story_Content.vue?vue&type=script&lang=js&"
export * from "./Story_Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports